import { render, staticRenderFns } from "./UsuarioFornecedorFormNovo.vue?vue&type=template&id=847874a6&lang=html"
import script from "./UsuarioFornecedorFormNovo.vue?vue&type=script&lang=js"
export * from "./UsuarioFornecedorFormNovo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports